import { type ComponentProps } from 'react';

import { cn } from '@air/utils-tailwind';

import { DRAG_PREVIEW_HEIGHT, DRAG_PREVIEW_WIDTH } from '~/constants/dnd';

export type DndDragPreviewContainer = ComponentProps<'div'>;

export const DndDragPreviewContainer = ({ className, style, ...props }: DndDragPreviewContainer) => {
  return (
    <div
      className={cn('rounded-16 bg-grey-1 shadow-drag-preview', className)}
      style={{
        height: DRAG_PREVIEW_HEIGHT,
        width: DRAG_PREVIEW_WIDTH,
        ...style,
      }}
      {...props}
    />
  );
};
